<template>
  <custom-dialog width="75%" :title="title" :visible="visible" v-on="$listeners" class="device-container-dialog">
    <div class="select-date">
      <h1>{{ $t('device_dialog_ri_qi') }}</h1>
      <div>
        <custom-date-picker :clearable="false" v-model="selectDate" value-format="YYYY-MM-DD HH:mm:ss" style="width: 162px" @change="changFilter"></custom-date-picker>
      </div>
    </div>
    <div class="dialog-body device-dialog-wrapper" style="padding-top: 0 !important">
      <div class="table-content" style="margin-top: 0">
        <div class="header">
          <div class="tab-box">
            <el-form :inline="true" @submit.native.prevent class="form-screen" style="display: flex">
              <el-form-item>
                <custom-select
                  url="productCodeSelectList"
                  v-model="formSearch.productCode"
                  :props="{ label: 'productCode', value: 'productCode' }"
                  @change="changFilter"
                  :placeholder="$t('device_dialog_quan_bu_xing_hao')"
                  width="180px"
                ></custom-select>
              </el-form-item>
              <el-form-item style="margin-left: 24px" v-if="model.type === 'location'">
                <custom-select
                  :listener="formSearch.locationId"
                  url="locationSiteList"
                  :model="formSearch"
                  v-model="formSearch.siteId"
                  :params="{ locationId: formSearch.locationId }"
                  :props="{ label: 'siteName', value: 'siteId', map: { siteName: 'siteName' } }"
                  :placeholder="$t('device_dialog_suo_you_qu_yu')"
                  @getList="getTagsList1"
                  :dataFilter="dataFilter1"
                  @change="onPageChange({ page: 1 })"
                  width="180px"
                ></custom-select>
              </el-form-item>
              <el-form-item style="flex: 1; text-align: center; margin-bottom: 0">
                <div class="status-type" style="padding-top:4px">
                  <ul>
                    <li class="item">
                      <i class="point"></i>
                      <p>
                        {{ $t('device_dialog_kong_xian') }}
                        <span>({{ countInfo.idle }})</span>
                      </p>
                    </li>
                    <li class="item">
                      <i class="point success"></i>
                      <p>
                        {{ $t('device_dialog_yun_xing_zhong') }}
                        <span>({{ countInfo.running }})</span>
                      </p>
                    </li>
                    <li class="item">
                      <i class="point warning"></i>
                      <p>
                        {{ $t('device_dialog_chong_dian_zhong') }}
                        <span>({{ countInfo.charging }})</span>
                      </p>
                    </li>
                    <li class="item">
                      <i class="point info"></i>
                      <p>
                        {{ $t('device_dialog_li_xian') }}
                        <span>({{ countInfo.offline }})</span>
                      </p>
                    </li>
                  </ul>
                </div>
              </el-form-item>
              <el-form-item style="margin-left: auto; margin-right: 0">
                <search-input width="240px" v-model="formSearch.search" :placeholder="$t('device_dialog_jshsbmc')" @fetch="onPageChange({ page: 1 })"></search-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table-bd" style="margin-top: 0">
          <ul class="device-list" v-if="tableList.length > 0">
            <li class="li" v-for="item in tableList" :key="item.bodyNum" @click="onJumpDetails(item)">
              <div class="item">
                <div class="img-box">
                  <img :src="getAttachUrl(item)" alt="" />
                </div>
                <div class="info">
                  <h3>{{ item.bodyNum }}</h3>
                  <p class="tag">
                    <span v-if="item.productCode">{{ item.productCode }}</span>
                    <span v-if="item.deviceName">{{ item.deviceName }}</span>
                    <span v-if="!formSearch.locationId && item.locationName">{{ item.locationName }}</span>
                    <span v-if="formSearch.locationId && item.siteName">{{ item.siteName }}</span>
                  </p>
                  <div class="state ub">
                    <div class="ub-f1 ub ub-xc">
                      <i class="icon icon-mianji"></i>
                      <span>{{ $formatLenLocal(item.totalCleanArea) }} {{ $formatLenUnit() }}</span>
                    </div>
                    <div class="ub-f1 ub ub-xc">
                      <i class="icon icon-shijian"></i>
                      <span>{{ Number.parseInt((item.totalUsageTime || 0) / 60, 10) | formatHourMinute }} h:m</span>
                    </div>
                  </div>
                </div>
                <div class="point" :class="item.deviceStateView"></div>
              </div>
            </li>
          </ul>
          <div class="no-data" v-else>{{ $t('com_no_data') }}</div>
        </div>
        <div class="page-footer">
          <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange" radius></custom-pagination>
        </div>
      </div>
    </div>
    <!-- <div slot="footer" class="dialog-footer"> -->
    <!-- <el-button size="small" @click="visible = false">取消</el-button> -->
    <!-- <el-button size="small" type="primary" @click="visible = false">确定</el-button> -->
    <!-- </div> -->
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

// device_dialog_ri_qi: 日期// device_dialog_kong_xian: 空闲// device_dialog_yun_xing_zhong: 运行中// device_dialog_chong_dian_zhong: 充电中// device_dialog_li_xian: 离线// device_dialog_quan_bu_xing_hao: 全部型号// device_dialog_suo_you_qu_yu: 所有区域// device_dialog_jshsbmc: 机身号/设备名称

export default {
  mixins: [dialogMixins],
  data() {
    return {
      title: '',
      selectDate: '',
      countInfo: {},
      formSearch: {
        search: '',
        pageNum: 1,
        pageSize: 50,
        orgId: '',
        locationId: '',
        siteId: '',
        productCode: '',
        date: '',
        isToday: false,
      },
      totalRows: 0,

      customerTagList: [],
      locationTagList: [],
      siteTagList: [],
      productTagList: [],
      mainStateTagList: [],
      secondStateTagList: [],

      tableList: [],
      type: '',
      floorId: '',
      tags1: []
    };
  },
  mounted() {
    this.mergeLanguage(null, 'portal_device_dialog');
    if (this.model.type === 'location') {
      this.selectDate = this.$moment.utc(this.model.selectDate).format('YYYY-MM-DD HH:mm:ss');
      this.formSearch.date = this.$moment.utc(this.model.selectDate).format('YYYY-MM-DD HH:mm:ss');
      this.formSearch.locationId = this.model.row.locationId;
    } else {
      this.selectDate = this.$moment.utc(this.model.selectDate).format('YYYY-MM-DD HH:mm:ss');
      this.formSearch.siteId = this.model.row.siteId;
      this.formSearch.isToday = this.isToday(this.selectDate);
    }
    this.getDeviceCount();
  },
  methods: {
    // 是否是当天
    isToday(date) {
      return this.$moment(date).isSame(this.$moment(), 'd') ? 1 : 0;
    },
    // 获取设备状态统计
    getDeviceCount() {
      const api = this.model.type === 'location' ? apis.reportDailyLocationDeviceCount : apis.ProtalDeviceCount;
      const params = this.model.type === 'location'
        ? {
          date: this.selectDate,
          locationId: this.formSearch.locationId,
        }
        : {
          date: this.selectDate,
          siteId: this.formSearch.siteId,
        };
      this.$getJSON(api, params).then((res) => {
        const data = res.data;
        if (this.isCoJv && !this.showSubsidiary) {
          this.title = `${data.locationName}${data.siteName ? '/' : ''}${data.siteName || ''}`;
        } else {
          this.title = `${data.orgName}${data.locationName ? '/' : ''}${data.locationName}${data.siteName ? '/' : ''}${data.siteName || ''}`;
        }
        this.countInfo = {
          idle: res.data.deviceCountList[0].num || 0,
          running: res.data.deviceCountList[1].num || 0,
          charging: res.data.deviceCountList[2].num || 0,
          offline: res.data.deviceCountList[3].num || 0,
        };
        this.formSearch.orgId = res.data.orgId;

        this.getTableList();
      });
    },
    onJumpDetails(item) {
      if (this.model.type === 'location' && item.isMyDevice === 0) {
        return;
      }
      this.jump('/other/device/accountDeviceDetail', {
        bodyNum: item.bodyNum,
        deviceId: item.deviceId,
      });
    },
    // 获取设备列表
    getTableList() {
      const api = this.model.type === 'location' ? apis.reportDailyLocationDevicePage : apis.ProtalDevicePage;
      this.formSearch.date = this.selectDate;
      this.$getJSON(api, this.formSearch).then(async (res) => {
        const deviceList = res.data.list || [];
        if (deviceList.length > 0) {
          const list = await this.formatAttachList(deviceList, 'productCodeId', 'dms.product.icon');
          const map = {
            1: 'warning',
            2: 'success',
            3: 'warning',
            4: 'info',
          };
          list.forEach((item) => {
            item.deviceStateView = map[item.deviceState];
          });
          this.tableList = list;
        } else {
          this.tableList = [];
        }
        this.totalRows = res.data.total;
      });
    },
    // 获取标签(区域)列表
    getTagsList1(list) {
      const arr = [];
      list.forEach((item) => {
        const isHas = arr.find(t => t.floorId === item.floorId);
        if (!isHas && item.floorId && item.floorName) {
          arr.push({
            floorId: item.floorId,
            floorName: item.floorName,
          });
        }
      });
      this.tags1 = arr;
    },
    // 过滤标签区域
    dataFilter1: function (list) {
      if (!this.floorId) {
        return list;
      }
      return list.filter(t => t.floorId === this.floorId);
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    changFilter: function () {
      this.formSearch.isToday = this.isToday(this.selectDate);
      this.getDeviceCount();
      this.onPageChange({ page: 1 });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.device-container-dialog {
  .custom-pagination {
    padding: 24px 0;
  }
  .state {
    .icon {
      font-size: 16px;
      color: #00a0d9;
    }
    span {
      font-size: 14px;
      color: #202945;
      margin-left: 6px;
    }
  }

  .select-date {
    padding-left: 18px;
    h1 {
      font-size: 12px;
      line-height: 17px;
      font-weight: bold;
      color: $--color-primary;
      margin-bottom: 4px;
      padding-left: 8px;
    }
    .el-input__prefix {
      color: $--color-primary;
      font-size: 18px;
      margin-right: 8px;
      margin-top: -1px;
    }
    .el-input .el-input__inner {
      cursor: pointer;
      height: 40px;
      line-height: 41px;
      padding-left: 34px;
      font-weight: bold;
      color: $--color-text-primary;
      border: none;
      font-size: 18px;
    }
    .el-input__suffix {
      margin-right: 30px;
      margin-top: -1px;
      margin-left: 12px;
      .el-input__icon:after {
        font-family: 'icon' !important;
        content: '\E7F8';
        font-size: 22px;
        color: $--color-warning;
        margin-bottom: 2px;
      }
    }
  }
}

.device-dialog-wrapper {
  .table-content {
    border-radius: 16px;
    background: #fff;
    margin-top: 24px;
    > .header {
      padding: 24px 0;
      .form-screen {
        display: flex;
        .el-form-item {
          margin-bottom: 0;
          align-self: center;
        }
        .label {
          color: #1a1a1a;
          line-height: 40px;
          font-weight: bold;
          float: left;
        }
        .status-type {
          align-self: center;
          ul {
            display: flex;
            li {
              height: 32px;
              line-height: 32px;
              border-radius: 47px;
              border: 1px solid #efefef;
              margin-right: 8px;
              padding: 0 12px;
              font-size: 0;
              display: flex;
              align-items: center;
              cursor: pointer;
              &.active {
                background: $--color-primary;
                p {
                  color: #fff;
                  font-family: PingFangSC-Semibold, PingFang SC;
                  span {
                    color: #fff;
                    font-family: PingFangSC-Regular, PingFang SC;
                  }
                }
                .point {
                  //  border: none;
                  // background-color: #fff !important;
                  position: absolute;
                  right: 0;
                  top: 0;
                  display: inline-block;
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                  background-color: $--color-info;
                  &.idle {
                    background-color: $--color-primary;
                  }
                  &.running {
                    background-color: $--color-success;
                  }
                  &.charging {
                    background-color: $--color-warning;
                  }
                  &.offline {
                    background-color: $--color-info;
                  }
                }
              }
              p {
                margin-left: 8px;
                font-size: 12px;
                color: #333333;
                line-height: 32px;
                font-size: 12px;
                font-weight: bold;
                color: $--color-text-regular;
                line-height: 18px;
                span {
                  font-size: 12px;
                  margin-left: 4px;

                  color: $--color-text-secondary;
                  line-height: 18px;
                }
              }
              .point {
                width: 10px;
                height: 10px;
                display: inline-block;
                background: $--color-primary;
                // border: 3px solid #e5e5e5;
                border-radius: 50%;
                &.danger {
                  background: $--color-danger;
                }
                &.warning {
                  background: $--color-warning;
                }
                &.success {
                  background: $--color-success;
                }
                &.info {
                  background: $--color-info;
                }
              }
            }
          }
        }

        .search-content {
          float: right;
        }
      }
    }

    .table-bd {
      height: 462px;
      width: 100%;
      overflow: hidden;
      .device-list {
        display: flex;
        flex-flow: row wrap;
        height: 472px;
        align-content: flex-start;
        margin-top: -10px;
        overflow-y: auto;
        .li {
          margin-top: 10px;
          margin-right: 10px;
          width: calc(33.3% - 10px);
          flex: 0 0 calc(33.3% - 10px);
          height: 108px;
          background: #ffffff;
          border-radius: 16px;
          border: 1px solid #f4f4f4;
          padding: 16px 16px 8px;
          cursor: pointer;
          &:hover {
            border-color: $--color-primary;
          }
          &:nth-child(3n + 3) {
            margin-right: 0;
          }
          .item {
            display: flex;
            position: relative;
            .img-box {
              width: 46px;
              height: 46px;
              flex: 0 0 46px;
              img {
                max-width: 100%;
                max-height: 100%;
              }
            }
            .info {
              flex: 1;
              margin-left: 16px;
              h3 {
                height: 20px;
                font-size: 16px;
                font-weight: bold;
                color: $--color-text-regular;
                line-height: 20px;
              }
              p {
                padding: 8px 0 12px 0;

                display: flex;
                span {
                  padding: 0 6px;
                  margin-right: 8px;
                  height: 18px;
                  background: #f4f4f4;
                  border-radius: 100px;
                  line-height: 18px;
                  font-size: 12px;
                }
              }
              .state {
                display: flex;
                // height: 22px;
                // line-height: 22px;

                .device-status-container {
                  // text-align: center;
                  font-size: 0;
                  // width: 140px;
                  margin-right: 26px;
                  .device-status {
                    font-size: 12px;
                    color: #4d4d4d;
                    // margin-top: 24px;
                    overflow: hidden;
                    display: inline-block;

                    > li {
                      float: left;
                      height: 22px;
                      &:nth-child(n + 2) {
                        margin-left: 10px;
                      }
                      &.signal {
                        .val {
                          padding-left: 2px;
                        }
                      }
                      .key {
                        float: left;
                        color: #00a0d9;
                        .icon {
                          float: left;
                          font-size: 18px;
                          line-height: 22px;
                        }
                      }
                      .val {
                        float: left;
                        margin-left: 2px;
                        line-height: 22px;
                      }
                    }
                  }
                }
                .device-state {
                  // position: absolute;
                  // top: 16px;
                  // right: -8px;

                  .device-state-tag {
                    $r: 22px;
                    // width: $r;
                    // height: $r;
                    border-radius: $r / 2;
                    // background: rgba(13, 154, 224, 0.05);
                    overflow: hidden;
                    float: left;
                    &.has-name {
                      // width: auto;
                      // padding-right: 10px;
                      line-height: $r;
                      .icon {
                        // margin-left: 9px;

                        &.icon-cleaning,
                        &.icon-free {
                          font-size: 18px;
                        }

                        &.icon-cleaning {
                          margin-top: 5px;
                        }
                        &.icon-suspend,
                        &.icon-free,
                        &.icon-charge {
                          margin-top: 4px;
                        }

                        &.icon-machine-offline {
                          margin-top: 5px;
                          font-size: 18px;
                        }
                      }
                    }
                    &:nth-child(n + 2) {
                      margin-left: 6px;
                    }

                    .icon {
                      $r: 18px;
                      width: $r;
                      height: $r;
                      text-align: center;
                      line-height: $r;
                      float: left;
                      margin-top: 3px;
                      margin-left: 3px;
                      font-size: 18px;

                      // &.icon-machine-offline,

                      &.blue {
                        color: $--color-primary;
                      }

                      &.red {
                        color: $--color-danger;
                      }
                      &.yellow {
                        color: $--color-warning;
                      }
                      &.gray {
                        color: $--color-info;
                      }
                      &.green {
                        color: $--color-success;
                      }
                    }

                    .state-name {
                      float: left;
                      font-size: 12px;
                      color: #495057;
                      margin-left: 3px;
                    }
                  }
                }
              }
            }
            .point {
              position: absolute;
              right: 0;
              top: 0;
              display: inline-block;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background-color: $--color-info;
              &.warning {
                background-color: $--color-primary;
              }
              &.running {
                background-color: $--color-success;
              }
              &.charging {
                background-color: $--color-warning;
              }
              &.offline {
                background-color: $--color-info;
              }
            }
          }
        }
      }
      .no-data {
        font-size: 16px;
        line-height: 140%;
        color: #818181;

        width: 100%;
        display: flex;
        height: 496px;
        justify-content: center;

        align-items: center;
        background-color: #fff;
      }
    }

    .page-footer {
      height: 88px;
    }
  }
}
</style>
